<template>
  <div class="membership-page">
    <div class="red_top_bg page-top">
      <div
        class="back_left"
        @click="$router.back()"
      />
      <div class="big_tit">
        {{ $t('membershipCard.title') }}
      </div>
    </div>

    <main class="membership-content">
      <section class="membership-card-shell">
        <div class="preview-frame">
          <section class="vip-card-preview">
            <img
              v-if="previewImageUrl"
              class="card-preview-img"
              :src="previewImageUrl"
              alt=""
            >
            <div
              v-else
              class="preview-placeholder"
            />
          </section>
        </div>

        <button
          type="button"
          class="download-btn"
          @click="downloadCard"
        >
          {{ $t('membershipCard.download') }}
        </button>
      </section>
    </main>
  </div>
</template>

<script>
import Fetch from '../../utils/fetch';
import vipCardBg from '../images/shop/vip.png';

export default {
  name: 'MembershipCard',
  data() {
    return {
      data: {},
      previewCanvas: null,
      previewImageUrl: ''
    };
  },
  computed: {
    cardImageCandidates() {
      return [vipCardBg];
    },
    vipCard() {
      return this.data && this.data.vip_card ? this.data.vip_card : {};
    },
    isAuthorized() {
      return Number(this.vipCard.authorized) === 1;
    },
    authText() {
      return this.isAuthorized ? this.$t('membershipCard.auth') : this.$t('membershipCard.unauth');
    },
    cardholder() {
      return this.vipCard.cardholder || this.data.mobile || this.data.name || '--';
    },
    cardNumber() {
      return this.vipCard.card_number || '--';
    },
    validityPeriod() {
      return this.isAuthorized && this.vipCard.valid_until ? this.vipCard.valid_until : '-';
    }
  },
  created() {
    this.$parent.footer('user', false);
  },
  mounted() {
    if (!localStorage.getItem('token')) {
      this.$router.push('/login');
      return;
    }
    this.start();
  },
  methods: {
    start() {
      Fetch('/user/info', {}, null, true).then((r) => {
        this.data = r.data || {};
        this.previewCanvas = null;
        this.previewImageUrl = '';
        this.safeRenderCardPreview();
      });
    },
    downloadCard() {
      if (!this.isAuthorized) {
        this.$toast(this.$t('membershipCard.activateFirst'));
        return;
      }
      var render = this.previewCanvas ? Promise.resolve(this.previewCanvas) : this.renderCardPreview();
      render.then((canvas) => {
        this.saveCanvas(canvas);
      }).catch(() => {
        this.$toast(this.$t('membershipCard.downloadFailed'));
      });
    },
    safeRenderCardPreview() {
      this.renderCardPreview().catch(() => {
        this.$toast(this.$t('membershipCard.downloadFailed'));
      });
    },
    renderCardPreview() {
      return this.renderCardFromCandidate(0).catch(() => {
        this.previewCanvas = null;
        this.previewImageUrl = '';
        return Promise.reject(new Error('card preview render failed'));
      });
    },
    renderCardFromCandidate(index) {
      var candidates = this.cardImageCandidates;
      if (index >= candidates.length) {
        return Promise.reject(new Error('card image load failed'));
      }
      return this.loadImage(candidates[index]).then((image) => {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = image.naturalWidth || image.width;
          canvas.height = image.naturalHeight || image.height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
          this.drawVipCard(ctx, canvas.width, canvas.height);
          this.previewCanvas = canvas;
          this.previewImageUrl = canvas.toDataURL('image/png');
          return canvas;
        } catch (e) {
          return this.renderCardFromCandidate(index + 1);
        }
      }).catch(() => this.renderCardFromCandidate(index + 1));
    },
    loadImage(src) {
      return new Promise((resolve, reject) => {
        var image = new Image();
        if (!this.isSameOrigin(src)) {
          image.crossOrigin = 'anonymous';
        }
        image.onload = function() {
          resolve(image);
        };
        image.onerror = reject;
        image.src = src;
      });
    },
    isSameOrigin(src) {
      try {
        var url = new URL(src, window.location.href);
        return url.protocol === 'data:' || url.protocol === 'blob:' || url.origin === window.location.origin;
      } catch (e) {
        return true;
      }
    },
    drawVipCard(ctx, width, height) {
      var sx = width / 976;
      var sy = height / 615;
      var scale = Math.min(sx, sy);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      this.drawSlotText(ctx, this.cardholder, 604 * sx, 259 * sy, 294 * sx, 54 * sy, 24 * scale, 16 * scale, false, 0);
      this.drawSlotText(ctx, this.cardNumber, 604 * sx, 385 * sy, 294 * sx, 54 * sy, 24 * scale, 16 * scale, false, 0);
      this.drawSlotText(ctx, this.validityPeriod, 604 * sx, 510 * sy, 294 * sx, 54 * sy, 24 * scale, 16 * scale, false, 0);
      this.drawSlotText(ctx, this.authText, 778 * sx, 112 * sy, 150 * sx, 42 * sy, 24 * scale, 14 * scale, true);

      ctx.shadowColor = 'transparent';
      ctx.shadowBlur = 0;
      ctx.textAlign = 'start';
      ctx.textBaseline = 'alphabetic';
    },
    drawSlotText(ctx, text, x, y, width, height, fontSize, minSize, compact, verticalOffset) {
      var size = fontSize;
      var content = String(text || '--');
      var maxWidth = width - (compact ? 18 : 34);
      var offsetY = verticalOffset || 0;

      do {
        ctx.font = '700 ' + size + 'px Arial, sans-serif';
        if (ctx.measureText(content).width <= maxWidth || size <= minSize) {
          break;
        }
        size -= 1;
      } while (size > minSize);

      ctx.fillStyle = '#fff7fb';
      ctx.shadowColor = compact ? 'rgba(29, 112, 255, 0.85)' : 'rgba(255, 82, 211, 0.92)';
      ctx.shadowBlur = compact ? 9 : 12;
      ctx.shadowOffsetX = 0;
      ctx.shadowOffsetY = 1;
      ctx.fillText(content, x + width / 2, y + height / 2 + offsetY);
    },
    saveCanvas(canvas) {
      var fileName = 'membership-card-' + (this.cardNumber === '--' ? this.data.uid : this.cardNumber) + '.png';
      if (canvas.toBlob) {
        canvas.toBlob((blob) => {
          if (!blob) {
            this.saveDataUrl(canvas, fileName);
            return;
          }
          var url = URL.createObjectURL(blob);
          this.downloadUrl(url, fileName);
          setTimeout(() => {
            URL.revokeObjectURL(url);
          }, 0);
        }, 'image/png');
        return;
      }
      this.saveDataUrl(canvas, fileName);
    },
    saveDataUrl(canvas, fileName) {
      this.downloadUrl(canvas.toDataURL('image/png'), fileName);
    },
    downloadUrl(url, fileName) {
      var link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style lang="less" scoped>
.membership-page {
  min-height: 100vh;
  padding-bottom: 80px;
  background: #191818;
  color: #f5f1ec;
  box-sizing: border-box;
}

button {
  border: 0;
  font: inherit;
  cursor: pointer;
}

.page-top {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #191818;
  color: #f5f1ec;
  border-bottom: 1px solid rgba(112, 90, 68, 0.45);
  box-sizing: border-box;
  .back_left {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1;
  }

  .big_tit {
    max-width: 72%;
    overflow: hidden;
    color: #ffc29f;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    text-align: center;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: normal;
  }
}

.membership-content {
  padding: 14px 16px 0;
}

.membership-card-shell {
  width: 100%;
  padding: 12px;
  overflow: hidden;
  border-radius: 14px;
  border: 1px solid rgba(128, 101, 74, 0.88);
  background: #292929;
  box-shadow: 0 12px 22px rgba(0, 0, 0, 0.22);
  box-sizing: border-box;
}

.preview-frame {
  padding: 0px;
  border-radius: 13px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  background: #232323;
  box-sizing: border-box;
}

.vip-card-preview {
  width: 100%;
  aspect-ratio: 976 / 615;
  position: relative;
  overflow: hidden;
  border-radius: 12px;
  border: 1px solid rgba(255, 208, 173, 0.16);
  background-color: #232323;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 0 14px 22px rgba(0, 0, 0, 0.28);
  box-sizing: border-box;
}

.card-preview-img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.preview-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #2c2521 0%, #171514 100%);
}

.download-btn {
  width: 100%;
  min-height: 52px;
  margin-top: 14px;
  border-radius: 10px;
  border: 1px solid rgba(198, 164, 130, 0.42);
  background: linear-gradient(180deg, #806348 0%, #604b38 100%);
  color: #ffd0ad;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  box-shadow: inset 0 1px 0 rgba(255, 222, 190, 0.18), 0 10px 18px rgba(0, 0, 0, 0.18);
}

@media screen and (max-width: 374px) {
  .membership-content {
    padding-right: 12px;
    padding-left: 12px;
  }

  .vip-card-preview {
    border-radius: 10px;
  }

  .membership-card-shell {
    padding: 10px;
  }

  .preview-frame {
    padding: 5px;
  }
}
</style>
